import axios from "axios";

export const axiosInstance = axios.create({
    baseURL: "https://api.fivea.in/api/v1",
    withCredentials: true
})

export const getALLCategory = async () => {
    const response = await axiosInstance.get('/categorys')
    return response.data
}

export const getCategory = async (id) => {
    const response = await axiosInstance.get(`/categorys/${id}`)
    return response.data
}

export const getAllProducts = async () => {
    const response = await axiosInstance.get('/products?isLive=true')
    return response.data
}

export const getAllLabels = async () => {
    const response = await axiosInstance.get('/labels')
    return response.data
}

export const getSettingJson = async () => {
    const response = await axiosInstance.get('/labels/6930911b179e149dfc233faf')
    return response.data
}

export const getProduct = async (id) => {
    const response = await axiosInstance.get(`/products/${id}`)
    return response.data
}

export const razorpayPayment = async (data) => {
    const response = await axiosInstance.post(`/payment/razorpay`, data)
    return response.data
}

export const applyPromo = async (data) => {
    const response = await axiosInstance.post(`/apply-promo`, data)
    return response.data
}